import React, { FC, useState, useMemo } from 'react';
import AppService from 'services/application/AppService';
import SidebarContext, { ISidebarContext } from 'common/contexts/SidebarContext';

interface ISidebarContextProvider {
  children: JSX.Element;
}

const SidebarContextProvider: FC<ISidebarContextProvider> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(AppService.getAppSidebarOpen());
  const [search, setSearch] = useState<string>('');

  const contextValue = useMemo((): ISidebarContext => {
    return {
      sidebarOpen,
      search,
      setSidebarOpen,
      setSearch,
    };
  }, [sidebarOpen, search]);

  return <SidebarContext.Provider value={contextValue}>{children}</SidebarContext.Provider>;
};

export default SidebarContextProvider;
